import React, { useState, useEffect, useRef } from 'react';
import { useDS5Controller } from '../hooks/useDS5Controller';
import { useMovementCache } from '../hooks/useMovementCache';
import { api } from '../services/api';
import './DepannageDS5Station.css';
import packageJson from '../../package.json';
import Cadance from './Cadance';
const APP_VERSION = packageJson.version;

const dep_MAPPING = {
  "Repair": {
    "Repaired": "Charging",
    "Refaire Test": "Full Test",
    "Not Repaired": "BER",
    "Dismount": "Dismount"
  }
};

const DepannageDS5Station = ({ userInfo, userPosition }) => {
  const {
    serialNumber,
    isConnected,
    BoardModel
  } = useDS5Controller();
  const [hourcount, setHourCount] = useState(0);
  const movementsCache = useMovementCache();
  const [selectedPannes, setSelectedPannes] = useState(null);
  const [selectedRebut, setselectedRebut] = useState(null);
  const [selectedNextJob, setSelectedNextJob] = useState(null);
  const [warning, setWarning] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [nextJob, setNextJob] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [currentMovementData, setCurrentMovementData] = useState(null);
  const [hasBeenProcessed, setHasBeenProcessed] = useState(false);
  const [selectedDep, setSelectedDep] = useState('');
  const [debugInfo, setDebugInfo] = useState('');
  const [PanneList, setPanneList] = useState([]);
  const [causeList, setCauseList] = useState([]);
  const isCheckingRef = useRef(false);
  const [isOpenPanne, setIsOpenPanne] = useState(false)
  const [isOpenRebut, setIsOpenRebut] = useState(false)
  const [isOpenNextJob, setIsOpenNextJob] = useState(false)
  const [isOpenDismountModal, setIsOpenDismountModal] = useState(false);
  const [dismountPannes, setDismountPannes] = useState([]);
  const [selectedDismountPanneId, setSelectedDismountPanneId] = useState('');
  const [modalError, setModalError] = useState('');
  const isRepairStation = userPosition === "Repair";
  const [movement, setmovement] = useState(null);
  const [Panne, setPanne] = useState('');
  const [date, setdate] = useState('');
  const [panneId, setPanneId] = useState(null);

  const getReparedPanne = async () => {
    if (PanneList.length !== 0) return;
    try {
      const Pannes = await api.getReparedPannedata();
      console.log(Pannes)
      let RepPanne = []
      for (let i = 0; i < Pannes.length; i++) {
        RepPanne.push(Pannes[i].description)
      }
      console.log(RepPanne)
      setPanneList(RepPanne);
    }
    catch (err) {
      console.error("Erreur vérification historique:", err);
      setWarning("cannot get panne list ");
    }
    finally {
    }
  };

  const getFailedTestKeys = (testObj) => {
    if (!testObj?.testTracking) return [];

    let tracking;
    try {
      tracking = typeof testObj.testTracking === 'string'
        ? JSON.parse(testObj.testTracking)
        : testObj.testTracking;
    } catch {
      return [];
    }

    const normalizeStepKey = (step) => {
      if (!step) return null;
      const [word, num] = step.toLowerCase().split(' ');
      return word + num.charAt(0).toUpperCase() + num.slice(1);
    };

    const failureStepKey = normalizeStepKey(tracking.failureStep);
    if (!failureStepKey || !tracking[failureStepKey]) return [];

    const stepObj = tracking[failureStepKey];
    const failedKeys = [];

    const extractKeys = async (obj, prefix = '') => {
      for (const [key, value] of Object.entries(obj)) {
        const fullKey = prefix ? `${prefix}.${key}` : key;

        if (failureStepKey === 'stepFive') {
          const id = testObj.code_ds5_id
          const code = await api.getCode(id)
          console.log('code panne', code.description)
          failedKeys.push(code.description + ' ,')
        }
        else if (failureStepKey === "stepSix" && (value === false)) {
          failedKeys.push(fullKey + ', ');
        }
        else if (
          (failureStepKey === 'stepOne' && value === true) ||
          (failureStepKey !== 'stepOne' && (value === false || value === null))
        ) {
          failedKeys.push(fullKey + ', ');
        }

        if (value && typeof value === 'object' && !Array.isArray(value)) {
          extractKeys(value, fullKey);
        }
      }
    };

    extractKeys(stepObj);
    return failedKeys;
  };

  const getRebut = async () => {
    if (causeList.length !== 0) return;
    try {
      const Causes = await api.getRebutata();

      let rebCause = []
      for (let i = 0; i < Causes.length; i++) {
        rebCause.push(Causes[i].cause)
      }
      console.log(rebCause)
      setCauseList(rebCause);
    }
    catch (err) {
      console.error("Erreur vérification historique:", err);
      setWarning("cannot get cause list ");
    }
    finally {
    }
  };

  const getDismountPannes = async () => {
    try {
      const pannesData = await api.getAllDs5Panne();
      const excludedPannes = ['Rayure légere', 'Grattage léger', 'Rayure profonde', 'Grattage profond'];
      const filteredPannes = Array.isArray(pannesData)
        ? pannesData.filter(p => !excludedPannes.includes(p.panne || p.name))
        : [];
      setDismountPannes(filteredPannes);
    } catch (err) {
      console.error("Error fetching pannes:", err);
      setDismountPannes([]);
    }
  };

  useEffect(() => {
    console.log('RepairStation - État complet:', {
      userInfo,
      userPosition,
      isRepairStation,
      isConnected,
      serialNumber,
      movementsCache: movementsCache ? Object.keys(movementsCache) : 'empty',
      hasBeenProcessed,
      selectedDep
    });

    setDebugInfo(`
      Station: ${userPosition}
      Connecté: ${isConnected}
      Serial: ${serialNumber}
      Cache: ${movementsCache ? Object.keys(movementsCache).length + ' mouvements' : 'loading'}
      Utilisateur: ${userInfo ? userInfo.user : 'none'}
      Réparation sélectionnée: ${selectedDep || 'Aucune'}
      Traité: ${hasBeenProcessed ? 'OUI' : 'NON'}
    `);
  }, [userInfo, userPosition, isConnected, serialNumber, movementsCache, hasBeenProcessed, selectedDep]);

  const getMovementNameById = (movementId) => {
    if (!movementsCache || Object.keys(movementsCache).length === 0) return null;

    for (const [name, id] of Object.entries(movementsCache)) {
      if (id === movementId) return name;
    }
    return null;
  };

  useEffect(() => {
    if (!isConnected || !serialNumber || serialNumber.includes('Error')) {
      console.log('En attente de connexion...');
      setWarning('');
      setCurrentMovementData(null);
      setHasBeenProcessed(false);
      setSelectedDep('');
      setPanne('');
      setdate('');
      setPanneId(null);
      return;
    }

    if (!movementsCache || Object.keys(movementsCache).length === 0) {
      console.log('En attente du cache des mouvements...');
      return;
    }

    const checkMovementHistory = async () => {
      if (isCheckingRef.current) return;

      isCheckingRef.current = true;
      try {
        console.log(`Vérification historique pour: ${serialNumber}`);
        const data = await api.getCurrentMovement(serialNumber);

        console.log(' Réponse API historique:', data);

        if (!data) {
          setWarning("Controller not in the database - Start with Quick Drift");
          setHasBeenProcessed(false);
          return;
        }

        console.log(data.id_nextjob);

        // Get panne_id if coming from Dismount
        if (data.id_movement === 15 && data.id_nextjob === 9) {
          setPanneId(data.panne_id);
          console.log('Coming from Dismount with panne_id:', data.panne_id);
        }

        if (data && data.id_movement === 1 && data.id_nextjob === 9) {
          const datapanne = await api.getPanne(data.id_movement, data.id_nextjob, serialNumber);
          console.log(datapanne)
          setPanne(datapanne.data[0].Panne_QuickDrift)
          const rawDate = datapanne.data[0].date
          const dateObj = new Date(rawDate);

          const formattedDate = `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          console.log("date formate", formattedDate)
          setdate(formattedDate);

        } else if (data && (data.id_movement === 5 || data.id_movement === 15) && data.id_nextjob === 9) {
          const datapanne = await api.getPanne(data.id_movement, data.id_nextjob, serialNumber);
          setPanne(datapanne.data[0].Panne)
          const rawDate = datapanne.data[0].date;

          const dateObj = new Date(rawDate);

          const formattedDate = `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          console.log("date formate", formattedDate)
          setdate(formattedDate);
        }
        else if (data && data.id_movement === 3 && data.id_nextjob === 9) {
          const datapanne = await api.getfulltestSession(serialNumber, data.date);
          console.log('this data session :', datapanne)
          console.log("this panne traited", getFailedTestKeys(datapanne))
          setPanne(getFailedTestKeys(datapanne))
          const rawDate = datapanne.startDate;

          const dateObj = new Date(rawDate);

          const formattedDate = `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
          console.log("date formate", formattedDate)

          setdate(formattedDate);
        }


        const movementName = getMovementNameById(data.id_movement);
        const nextJobName = getMovementNameById(data.id_nextjob);

        const processedData = {
          ...data,
          movement: movementName,
          nextjob: nextJobName,
          id_movement: data.id_movement,
          id_nextjob: data.id_nextjob
        };
        setmovement(movementName)
        setCurrentMovementData(processedData);

        console.log('Données traitées:', processedData);

        if (processedData.nextjob !== "Repair") {
          setWarning(`Next_Job : ${processedData.nextjob || 'Aucun'}`);
          setHasBeenProcessed(false);
          return;
        }

        setWarning('');
        console.log('Manette valide pour Repair Station');

      } catch (err) {
        console.error("Erreur vérification historique:", err);
        if (err.message.includes('404')) {
          setWarning("Controller not in database - Start with Quick Drift");
        } else {
          setWarning("Erreur de vérification de l'historique");
        }
        setHasBeenProcessed(false);
      } finally {
        isCheckingRef.current = false;
      }
    };
    checkMovementHistory();
  }, [isConnected, serialNumber, movementsCache, PanneList]);

  const saveToDatabase = async (repairType, customNextJob = null, dismountPanneId = null) => {
    if (!userInfo || !userInfo.id) {
      setWarning("Aucun opérateur connecté. Veuillez vous authentifier.");
      return;
    }

    if (!currentMovementData || !movementsCache || Object.keys(movementsCache).length === 0) {
      setWarning("Données manquantes pour l'enregistrement");
      return;
    }

    const nextJobTarget = customNextJob || dep_MAPPING["Repair"][repairType];
    const movementId = movementsCache["Repair"];
    const nextJobId = movementsCache[nextJobTarget];

    if (!movementId || !nextJobId) {
      console.error(`IDs non trouvés dans le cache: Repair=${movementId}, ${nextJobTarget}=${nextJobId}`);
      setWarning("Erreur: IDs des mouvements non trouvés");
      return;
    }

    const payload = {
      serial_number: serialNumber,
      operator: userInfo.id,
      tester: "Repair",
      movement: movementId,
      nextjob: nextJobId,
      Grade: null,
      cause_rebut: selectedRebut,
      repaired_panne: selectedPannes,
      panne: dismountPanneId ? Number(dismountPanneId) : null,
      version: APP_VERSION
    };

    console.log("Payload envoyé à l'API:", payload);

    try {
      setIsSaving(true);
      await api.saveMovement(payload);
      setIsOpenPanne(false);
      setIsOpenRebut(false);
      setIsOpenNextJob(false);
      setIsOpenDismountModal(false);
      setNextJob(nextJobTarget);
      setShowSuccess(true);
      setHasBeenProcessed(true);
      setSelectedDep(repairType);
      if (selectedDep !=="Refaire Test") {
        setHourCount(prev => prev + 1)
      }

      console.log('Enregistrement réussi - Message permanent');

    } catch (err) {
      console.error("Erreur sauvegarde:", err);
      setWarning(`Erreur enregistrement: ${err.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handlePanneConfirm = () => {
    setIsOpenPanne(false);
    setIsOpenNextJob(true);
  };

  const handleDismountConfirm = () => {
    setModalError('');

    if (!selectedDismountPanneId) {
      setModalError("Veuillez sélectionner un type de panne");
      return;
    }

    saveToDatabase("Dismount", null, selectedDismountPanneId);
  };

  useEffect(() => {
    const resetHourlyCount = () => {
      if (typeof hourCount === 'function') return;
      setHourCount(0);
    };

    const now = new Date();
    const msUntilNextHour =
      (60 - now.getMinutes()) * 60 * 1000 -
      now.getSeconds() * 1000 -
      now.getMilliseconds();

    const timeoutId = setTimeout(() => {
      resetHourlyCount();
      const intervalId = setInterval(resetHourlyCount, 60 * 60 * 1000);
      return () => clearInterval(intervalId);
    }, msUntilNextHour);

    return () => clearTimeout(timeoutId);
  }, [setHourCount]);

  useEffect(() => {
    setShowSuccess(false);
    setNextJob('');
    setCurrentMovementData(null);
    setWarning('');
    setHasBeenProcessed(false);
    setSelectedDep('');
  }, [serialNumber]);

  const handleToggle = (item) => {
    setSelectedPannes(prev => {
      if (!prev) {
        return item;
      }

      const list = prev.split("|||");

      if (list.includes(item)) {
        const updated = list.filter(p => p !== item);
        return updated.join("|||");
      } else {
        return [...list, item].join("|||");
      }
    });
  };

  const handleTogglerebut = (item) => {
    setselectedRebut(prev => {
      if (!prev) {
        return item;
      }

      const list = prev.split("|||");

      if (list.includes(item)) {
        const updated = list.filter(p => p !== item);
        return updated.join("|||");
      } else {
        return [...list, item].join("|||");
      }
    });
  };

  return (
    <div className="repair-container">
      {
        <div>
          {isConnected && isOpenPanne && (<div className="overlay">
            <div className="popup">
              <h3>Select repaired panne</h3>

              <div className="checkboxList">
                {PanneList.map((item) => (
                  <label key={item} className="checkboxItem">
                    <input
                      type="checkbox"
                      checked={selectedPannes && selectedPannes.split("|||").includes(item)}
                      onChange={() => handleToggle(item)}
                    />
                    {` ${item}`}
                  </label>
                ))}
              </div>

              <div className='buttonContainer'>
                <button className="cancelBtn" onClick={() => setIsOpenPanne(false)} >Cancel</button>
                <button className="confirmBtn" onClick={handlePanneConfirm} >Next</button>
              </div>
            </div>
          </div>
          )}

          {isConnected && isOpenNextJob && (<div className="overlay">
            <div className="popup">
              <h3>Select Next Job</h3>

              <div className="checkboxList">
                <label className="checkboxItem">
                  <input
                    type="radio"
                    name="nextJob"
                    checked={selectedNextJob === "Full Test"}
                    onChange={() => setSelectedNextJob("Full Test")}
                  />
                  {` Full Test`}
                </label>
                <label className="checkboxItem">
                  <input
                    type="radio"
                    name="nextJob"
                    checked={selectedNextJob === "Charging"}
                    onChange={() => setSelectedNextJob("Charging")}
                  />
                  {` Charging`}
                </label>
              </div>

              <div className='buttonContainer'>
                <button className="cancelBtn" onClick={() => {
                  setIsOpenNextJob(false);
                  setIsOpenPanne(true);
                }} >Back</button>
                <button
                  className="confirmBtn"
                  onClick={() => saveToDatabase("Repaired", selectedNextJob)}
                  disabled={!selectedNextJob}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
          )}

          {isConnected && isOpenRebut && (<div className="overlay">
            <div className="popup">
              <h3>Select rebut cause</h3>

              <div className="checkboxList">
                {causeList.map((item) => (
                  <label key={item} className="checkboxItem">
                    <input
                      type="checkbox"
                      checked={selectedRebut && selectedRebut.split("|||").includes(item)}
                      onChange={() => handleTogglerebut(item)}
                    />
                    {` ${item}`}
                  </label>
                ))}
              </div>

              <div className='buttonContainer'>
                <button className="cancelBtn" onClick={() => setIsOpenRebut(false)} >Cancel</button>
                <button className="confirmBtn" onClick={() => saveToDatabase("Not Repaired")} disabled={!selectedRebut || selectedRebut.trim() === ""}>Confirm</button>
              </div>
            </div>
          </div>
          )}

          {isConnected && isOpenDismountModal && (
            <div className="overlay">
              <div className="popup">
                <h3>Sélectionner le type de panne</h3>
                {modalError && <div className="message error-message modal-error">{modalError}</div>}

                <div className="modal-field">
                  <label>Type de panne:</label>
                  <select
                    value={selectedDismountPanneId}
                    onChange={e => {
                      setSelectedDismountPanneId(e.target.value);
                      setModalError('');
                    }}
                  >
                    <option value="">-- Choisir une panne --</option>
                    {dismountPannes.map(p => (
                      <option key={p.id} value={p.id}>{p.panne || p.name}</option>
                    ))}
                  </select>
                </div>

                <div className='buttonContainer'>
                  <button className="cancelBtn" onClick={() => {
                    setIsOpenDismountModal(false);
                    setSelectedDismountPanneId('');
                    setModalError('');
                  }}>Cancel</button>
                  <button className="confirmBtn" onClick={handleDismountConfirm}>Confirm</button>
                </div>
              </div>
            </div>
          )}
        </div>
      }

      <Cadance userInfo={userInfo} movementId={9} hourCount={hourcount} />

      <div>
        <div className="repair-header">
          <h1>Repair</h1>
        </div>

        {!isConnected && (
          <div className="connection-section">
            <div className="disconnected">
              <h1>🔌 Plug in your DualSense controller.</h1>
            </div>
          </div>
        )}

        {isConnected && (
          <div className="connected-section">
            <div className="serial-display">
              <label>Serial Number</label>
              <div className="serial-value">{serialNumber}</div>

              <label>Board Model :</label>
              <div className="serial-value">{BoardModel}</div>
            </div>

            {warning && (
              <div className="message warning-message">
                {warning}
              </div>
            )}

            {currentMovementData && (currentMovementData.id_nextjob === 9) && (
              <div className="panne-container">
                <table className="panne-table">
                  <tbody>
                    <tr>
                      <td>movement</td>
                      <td>{movement}</td>
                    </tr>
                    <tr>
                      <th>Panne</th>
                      <td>{Panne}</td>
                    </tr>
                    <tr>
                      <td>date</td>
                      <td>{date}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {isSaving && (
              <div className="message waiting-message">
                Enregistrement en cours...
              </div>
            )}

            {showSuccess && nextJob && (
              <div className="message success-message permanent">
                <div className="success-details">
                  <div><strong>Next Job:</strong> <span className="next-job">{nextJob}</span></div>
                </div>
              </div>
            )}

            {!hasBeenProcessed && currentMovementData && currentMovementData.nextjob === "Repair" &&
              !isSaving && !showSuccess && userInfo && (
                <div className="repair-buttons-section">
                  <div className="repair-buttons-row">
                    <button
                      onClick={() => {
                        getReparedPanne();
                        setIsOpenPanne(true);
                      }}
                      disabled={isSaving}
                      className={`btn-repair btn-repared ${selectedDep === "Repaired" ? "selected" : ""}`}
                    >
                      {isSaving && selectedDep === "Repaired" ? '⏳...' : 'Repaired'}
                    </button>

                    <button
                      onClick={() => saveToDatabase("Refaire Test")}
                      disabled={isSaving}
                      className={`btn-repair btn-retest ${selectedDep === "Refaire Test" ? "selected" : ""}`}
                    >
                      {isSaving && selectedDep === "Refaire Test" ? '⏳...' : 'Refaire Test'}
                    </button>

                    <button
                      onClick={() => {
                        getDismountPannes();
                        setIsOpenDismountModal(true);
                      }}
                      disabled={isSaving}
                      className={`btn-repair btn-dismount ${selectedDep === "Dismount" ? "selected" : ""}`}
                    >
                      {isSaving && selectedDep === "Dismount" ? '⏳...' : 'Dismount'}
                    </button>

                    <button
                      onClick={() => {
                        getRebut();
                        setIsOpenRebut(true);
                      }}
                      disabled={isSaving}
                      className={`btn-repair btn-notrepared ${selectedDep === "Not Repaired" ? "selected" : ""}`}
                    >
                      {isSaving && selectedDep === "Not Repaired" ? '⏳...' : 'BER'}
                    </button>
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DepannageDS5Station;